
import { PropType, defineComponent } from 'vue';
import NearbyTrailerResult from '@/types/NearbyTrailerResult';
import TrailerMapPoint from '@/types/TrailerMapPoint';
import Geopoint from '@/types/Geopoint';
import { NearbyTrailerResultType } from '@/types/NearbyTrailerResultType';
import { trailerType } from '@/shared/helpers';
import { CargoStatus } from '@/types/CargoStatus';

export default defineComponent({
    props: {
        result: {
            required: true,
            type: NearbyTrailerResult,
        },
        selectedResult: Object as PropType<NearbyTrailerResult | null>,
    },
    computed: {
        lastUpdated(): string | undefined {
            const age = this.result.trailers[0].sourceLastReported;
            if (age === null || age === undefined) return 'Last update unknown';
            else {
                const timestamp = age.toRelative({
                    unit: ['days', 'hours', 'minutes'],
                });
                const value = timestamp
                    ?.split(' ')
                    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
                    .join(' ');
                return `Updated ${value}`;
            }
        },
        hasAnyFault() {
            return (
                this.hasDotExpired === true || this.hasCargoSensorError === true
            );
        },
        hasDotExpired(): boolean {
            return this.result.trailers[0].isDotInspectionExpired === true;
        },
        hasCargoSensorError(): boolean {
            return (
                this.result.trailers[0].cargoStatus ===
                    CargoStatus.SENSOR_ERROR ||
                this.result.trailers[0].cargoStatus === CargoStatus.NO_SENSOR
            );
        },
        validTrailerType(): boolean {
            return (
                this.trailerTypeText !== undefined &&
                this.trailerTypeText.length > 0
            );
        },
        trailerTypeText(): string {
            return trailerType(this.result.trailers[0]);
        },
        name(): string | undefined {
            if (
                (this.isReserved &&
                    this.result?.type ===
                        NearbyTrailerResultType.standaloneTrailer) ||
                this.result?.type === NearbyTrailerResultType.customerLocation
            ) {
                return `Your Trailer #${this.result.trailers[0].trailerNumber}`;
            } else {
                return `Trailer #${this.result.trailers[0].trailerNumber}`;
            }
        },
        selectedClass(): string {
            return this.selectedResult?.trailers[0]?.id ===
                this.result.trailers[0].id
                ? 'selected'
                : '';
        },
        icon() {
            const point =
                this.result?.location || ({ lat: 0, lng: 0 } as Geopoint);
            const pin = new TrailerMapPoint(point, this.result).icon;
            pin.classList.remove('map-icon');
            return pin.outerHTML;
        },
        isReserved(): boolean {
            return (
                this.result.trailers.filter((x) => x.reservation?.isActive)
                    .length > 0
            );
        },
        reservationEndTime(): string | undefined {
            if (this.isReserved) {
                return this.result.trailers[0].reservation?.expiresAt
                    .toLocal()
                    .toFormat('hh:mma')
                    .toLowerCase();
            } else {
                return undefined;
            }
        },
        timeZone(): string | undefined {
            return new Date()
                .toLocaleTimeString('en-us', { timeZoneName: 'short' })
                .split(' ')[2];
        },
    },
});
